module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/delariva-attacking/off-balance-sweep-to-berimbolo/off-balance-sweep-to-berimbolo.component.css
// module id = ./src/app/delariva-attacking/off-balance-sweep-to-berimbolo/off-balance-sweep-to-berimbolo.component.css
// module chunks = main